import React from "react";

import styles from "../Footer.module.scss";

const MensagemStepforma = () => (
    <>
        <div className={styles.sentence}>Ensinar e aprender é mais fácil com a Stepforma.</div>
        <div className={styles.sentence}>Tenha tudo em um só lugar!</div>
    </>
);

export default MensagemStepforma;
